/** Valeurs par défaut de la prescription à la création d'une commande. */
export const DEFAULT_CASE_PRESCRIPTION = {
  archToTreat: 'both',
  treatmentType: 'Full Arch',
  overjet: 'Improve',
  overbite: 'Improve',
  midline: 'Improve',
  posteriorCrossbite: 'Improve',
  spacing: 'Close All',
  sequentialDistalization: 'Yes',
  expand: { upper: 'As Needed', lower: 'As Needed' },
  procline: { upper: 'As Needed', lower: 'As Needed' },
  canine: { upper: 'Improve', lower: 'Improve' },
  molar: { upper: 'Improve', lower: 'Improve' },
  iprAnterior: { upper: 'As Needed', lower: 'As Needed' },
  iprPosteriorRight: { upper: 'As Needed', lower: 'As Needed' },
  iprPosteriorLeft: { upper: 'As Needed', lower: 'As Needed' },
  toothMovementRestrictions: [],
  attachmentRestrictions: [],
  extractions: [],
  missingTeeth: [],
  questionsNotes: '',
};

export function buildDefaultCasesPrescriptionFields() {
  return {
    arch_to_treat: DEFAULT_CASE_PRESCRIPTION.archToTreat,
    treatment_type: DEFAULT_CASE_PRESCRIPTION.treatmentType,
  };
}

export function buildDefaultTreatmentSpecsRow(caseId) {
  const p = DEFAULT_CASE_PRESCRIPTION;
  return {
    case_id: caseId,
    overject: p.overjet,
    overbite: p.overbite,
    midline: p.midline,
    posterior_crossbite: p.posteriorCrossbite,
    spacing: p.spacing,
    sequential_distalization: p.sequentialDistalization,
    expand: p.expand,
    procline: p.procline,
    canine: p.canine,
    molar: p.molar,
    ipr_anterior: p.iprAnterior,
    ipr_posterior_right: p.iprPosteriorRight,
    ipr_posterior_left: p.iprPosteriorLeft,
    tooth_mvt_restrictions: p.toothMovementRestrictions,
    attachment_restrictions: p.attachmentRestrictions,
    extractions: p.extractions,
    missing_teeth: p.missingTeeth,
  };
}

/** Initialise case_treatment_specs pour une commande nouvellement créée. */
export async function seedDefaultCasePrescription(supabaseClient, caseId) {
  const { error } = await supabaseClient
    .from('case_treatment_specs')
    .insert(buildDefaultTreatmentSpecsRow(caseId));

  if (error) throw error;
}

function normalizeArchForAssistant(value) {
  const normalized = String(value || '').toLowerCase();
  if (normalized === 'upper') return 'Upper';
  if (normalized === 'lower') return 'Lower';
  if (normalized === 'both') return 'Both';
  return value || '';
}

/** État initial du formulaire assistant (arcades en Title case). */
export function getDefaultAssistantPrescriptionForm() {
  return {
    ...DEFAULT_CASE_PRESCRIPTION,
    archToTreat: normalizeArchForAssistant(DEFAULT_CASE_PRESCRIPTION.archToTreat),
  };
}
